<template>
	<q-dialog v-model="myaddmodal" transition-show="fade" transition-hide="fade">
		<div class="hris-modal hris-modal-lg">
			<div class="hris-modal-header">
				<div>
					<h2 class="hris-modal-title">Add Announcement</h2>
					<p class="hris-modal-subtitle">Publish a new update or notice for employees.</p>
				</div>
				<q-btn flat dense round v-close-popup aria-label="Close">
					<i class="fas fa-times"></i>
				</q-btn>
			</div>
			<div class="hris-modal-body">
				<div class="hris-form-row">
					<div class="hris-form-field" style="flex-basis: 100%;">
						<q-input outlined dense color="green" label="Subject" ref="subj" v-model="subject" :rules="[val => !!val || 'Subject is required']"></q-input>
					</div>
				</div>
				<div class="hris-form-row">
					<div class="hris-form-field" style="flex-basis: 100%;">
						<q-input outlined dense color="green" label="Body" ref="message" v-model="message" type="textarea" :rules="[val => !!val || 'Body is required']"></q-input>
					</div>
				</div>
				<div class="hris-form-row">
					<div class="hris-form-field" style="flex-basis: 100%;">
						<q-file outlined dense color="green" v-model="file" id="file" label="Pick one file" ref="file" accept="image/*,.pdf" :rules="[val => !!val || 'Attachment is required']">
							<template v-slot:prepend>
								<i class="fas fa-paperclip"></i>
							</template>
						</q-file>
					</div>
				</div>
			</div>
			<div class="hris-modal-footer">
				<q-btn unelevated class="hris-q-outline" label="Close" v-close-popup></q-btn>
				<q-btn unelevated class="hris-q-primary" label="Save" type="submit" @click="addAnnouncement"></q-btn>
			</div>
		</div>
	</q-dialog>
</template>

<script>
	import axios from 'axios';
	import mixins from '../../mixins';
export default {
  	data () {
	    return {
	      myaddmodal: false,
	      date: null,
	      subject: '',
	      message: '',
	      file: null,
	      text: '',
	      dense: false,
	      selectedFile: null
	    }
 	},

    created() {
    	this.eventHub.$on('openAddModal', this.openAddModal);
    },

    methods: {
    	openAddModal:function(props){
    		this.myaddmodal = props.stat;
		},

	    pickFile() {
	    	this.file = this.$refs.file.files[0];
	    },

	    onUpload(){
	    	let formData = new FormData();
	    	formData.append("file", this.file, this.file.name);
	    	axios.post('/announcement/file',formData)
	    	.then(res => {
	    		console.log("res", res);
	    	});
	    },
	    addAnnouncement:function(){
			this.spinner=true;
			let formData = new FormData();

			// START:: 11-03-2020 NICELE 11:36AM
			this.$refs.subj.validate()
		    this.$refs.message.validate()
		    this.$refs.file.validate()

		    if (this.$refs.subj.hasError || this.$refs.message.hasError || this.$refs.file.hasError) {
		        this.formHasError = true
		    }else {
		        formData.append("subject", this.subject);
				formData.append("message", this.message);
				formData.append("files", this.file);

				console.log(formData)
				axios.create({
					baseURL : this.apiUrl,
					headers : {'Authorization' : `Bearer ${this.token}`}
				}).post('/announcement/add',formData)
				.then((res) => {
					console.log(res)
					this.myaddmodal = false;
					this.eventHub.$emit('addAnnouncement');
	            	this.$data.subject = "";
	            	this.$data.message = "";
	            	this.$data.file = "";
	            	this.$data.date = null;

	            	this.$q.notify({
			          color: 'positive',
			          message: 'Submitted'
			        })

				});
		    }
			// END:: 11-03-2020 NICELE 11:36AM

		},

    }

}
</script>
